import { render } from "./AeracaoContent.vue?vue&type=template&id=281e31a4&scoped=true"
import script from "./AeracaoContent.vue?vue&type=script&lang=js"
export * from "./AeracaoContent.vue?vue&type=script&lang=js"

import "./AeracaoContent.vue?vue&type=style&index=0&id=281e31a4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281e31a4"]])

export default __exports__